import { AuthEffects } from '@app/auth/store/effects/auth.effects';
export const effects: any[] = [AuthEffects];

export * from '@app/auth/store/effects/auth.effects';
